import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { LoadingIndicator } from 'common/components/preloader';
import InviteForm from 'invite/containers/form';

export default class InviteModal extends Component {
  componentDidMount() {
    this.props.fetchProjects();
  }

  render() {
    const {
      creative, closeInviteModal, isLoadingProjects, success, projectId, projects
    } = this.props;

    if (!creative) {
      return null;
    }

    const header = success ? '' : `Invite ${creative.username}`;

    return (<ModalDialog
      modalOpen={true}
      closeAction={closeInviteModal}
      modalHeader={header}
      dialogClasses="invite-modal"
    >
      { isLoadingProjects && <LoadingIndicator /> }
      { success && <div className="invite-success">
        <i className="fa fa-check-circle" />
        <h2>Invite Successful</h2>
        <div className="modal-actions">
          <button onClick={closeInviteModal} className="btn btn-tertiary">Done</button>
        </div>
      </div> }

      { projects.length == 0 && <div>
        <h2>You have no projects for which you can invite creatives at the moment.</h2>
        <div className="modal-actions">
          <button onClick={closeInviteModal} className="btn btn-tertiary">Close</button>
        </div>
      </div> }

      { projects.length > 0 && !isLoadingProjects && !success &&
      <InviteForm creative={creative} projectId={projectId} /> }
    </ModalDialog>);
  }
}

InviteModal.propTypes = {
  creative: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
  }),
  closeInviteModal: PropTypes.func.isRequired,
  fetchProjects: PropTypes.func.isRequired,
  isLoadingProjects: PropTypes.bool,
  projects: PropTypes.array,
  success: PropTypes.bool,
  projectId: PropTypes.string,
};
